import { render } from "./Tal_attachFile.vue?vue&type=template&id=2b9360ce&scoped=true"
import script from "./Tal_attachFile.vue?vue&type=script&lang=js"
export * from "./Tal_attachFile.vue?vue&type=script&lang=js"

import "./Tal_attachFile.vue?vue&type=style&index=0&id=2b9360ce&scoped=true&lang=css"
/* custom blocks */
import block0 from "./Tal_attachFile.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9360ce"]])

export default __exports__